<div [ngClass]="applyStyling ? 'lightly-padded chart' : ''">
  <div [ngClass]="applyStyling ? 'boxwrapper' : ''" *ngIf="type && options && chart">
    <div [chart]="chart"></div>
  </div>
</div>

